module.exports = __webpack_public_path__ + "img/23_68.a773dbd4.png";